import { useEffect, useState } from "react";
import styles from "./Leaflet.module.css";
import "leaflet/dist/leaflet.css";

let MapContainer,
  TileLayer,
  Marker,
  Popup,
  CircleMarker,
  L,
  Tooltip,
  ImageOverlay;
let Bounds, CRS, Proj4, Proj4Leaflet;

const LeafletMap = (props) => {
  const [show, setShow] = useState(false);
  const [markers, setMarkers] = useState([]);

  useEffect(() => {
    if (show && "shown" in props) {
      setTimeout(() => {
        props.shown();
      }, 1000);
    }
  }, [show]);

  useEffect(() => {
    const leafletres = (async () => await import("react-leaflet"))().then(
      (i) => i
    );
    fetch(`/api/getMapData?variable=${props.variable}`)
      .then((res) => res.json())
      .then((json) => {
        leafletres.then((reactLeaflet) => {
          MapContainer = reactLeaflet.MapContainer;
          TileLayer = reactLeaflet.TileLayer;
          Marker = reactLeaflet.Marker;
          Popup = reactLeaflet.Popup;
          CircleMarker = reactLeaflet.CircleMarker;
          Tooltip = reactLeaflet.Tooltip;

          // CRS = require("leaflet").CRS;
          Proj4 = require("proj4");
          Proj4Leaflet = require("proj4leaflet");
          L = require("leaflet");
          // delete L.Icon.Default.prototype._getIconUrl;
          // L.Icon.Default.mergeOptions({
          //   iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
          //   iconUrl: require("leaflet/dist/images/marker-icon.png"),
          //   shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
          // });
          Bounds = new L.LatLngBounds([39.33, -89.34], [36.29, -82.1]);
          CRS = new L.Proj.CRS(
            "EPSG:3088",
            "+proj=lcc +lat_1=37.08333333333334 +lat_2=38.66666666666666 " +
              // bigger positive x shifts everything to the rightbigger negative y shifts everything down
              "+lat_0=36.33333333333334 +lon_0=-85.75 +x_0=344500 +y_0=-486500 " +
              "+ellps=GRS80 +datum=NAD83 +units=m +no_defs",
            {
              // bigger first number pulls points closer together make the second number half the first, the third half the second, etc.
              resolutions: [2664, 1332, 666, 333],
            }
          );
          const tMarkers = [];
          for (let stid in json) {
            const data = json[stid];
            const latLon = [Number(data.Lat), Number(data.Lon)];
            //   const MARKER_FILL_COLOR = "#EFEFEF",
            //   MARKER_HIGHLIGHT_COLOR = "#00ccff",
            //   MARKER_BORDER_COLOR = "#222222",
            tMarkers.push(
              <CircleMarker
                key={stid}
                center={latLon}
                color={"#222222"}
                fill={true}
                fillColor={"#EFEFEF"}
                fillOpacity={0.8}
                radius={8}
                weight={2}
                opacity={0.9}
                // fill: true,
                // fillColor:
                //   i === this.selectedStation
                //     ? MARKER_HIGHLIGHT_COLOR
                //     : MARKER_FILL_COLOR,
                // fillOpacity: 0.8,
                // radius: 8,
                // clickable: true,
                // weight: 2,
                // opacity: 0.9,
                // draggable: false,
              >
                <Tooltip
                  permanent={true}
                  className={styles.nopadding}
                  opacity={0.85}
                  direction="top"
                >
                  {parseFloat(data[props.variable]).toFixed(2)}
                </Tooltip>
              </CircleMarker>
            );
          }
          setMarkers(tMarkers);
          setShow(true);
        });
      });
  }, [props]);

  return show && MapContainer ? (
    <MapContainer
      center={[37.875, -85.805]}
      zoom={2}
      style={{ height: "480px" }}
      crs={CRS}
      bounds={Bounds}
    >
      <TileLayer
        // attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        // url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        url={`https://www.kymesonet.org/imgs/tiles/${
          props.variable
        }/{z}/{x}/{y}.png?t=${Math.ceil(Date.now() / 60000)}`}
        noWrap={true}
        minZoom={2}
        maxZoom={3}
        bounds={Bounds}
      />
      {markers}
    </MapContainer>
  ) : (
    "Refresh to load map"
  );
};

export default LeafletMap;
